<h2 class="form-title-row form-title">{{ "uploadData.rnaMutation.title" | translate }}</h2>

<!-- Biobank + Sample ID -->
<div class="form-grid">
  <div class="form-group">
    <label for="biobank-select" class="form-label">{{ "biobankSource.label" | translate }} *</label>
    <select *ngIf="!isModal" id="biobank-select" class="form-select" [(ngModel)]="selectedBiobankId" (change)="onBiobankChange()">
      <option value="">{{ "biobankSource.placeholder" | translate }}</option>
      <option *ngFor="let biobank of biobanks" [ngValue]="biobank.id">{{ biobank.name }} ({{ biobank.acronym }})</option>
    </select>
    <div *ngIf="isModal" id="biobank-select" class="static-field">
      {{ initialBiobankName }}
    </div>
  </div>

  <div class="form-group">
    <div class="form-label-row">
      <label for="sample-id" class="form-label">{{ "sampleId.title" | translate }}</label>

      <div class="status-indicators">
        <ng-container *ngIf="!isLoadingRNAMut; else loadingStatus">
          <span class="status-label">{{ "samplesPage.hasRnaSeq" | translate }}:</span>
          <span [ngClass]="overviewData?.hasRnaSeq | rnaMutClassText">
            {{ overviewData?.hasRnaSeq | rnaMutStatusText | translate }}
          </span>

          <span class="status-label">{{ "samplesPage.hasMutation" | translate }}:</span>
          <span [ngClass]="overviewData?.hasMutation | rnaMutClassText">
            {{ overviewData?.hasMutation | rnaMutStatusText | translate }}
          </span>
        </ng-container>

        <ng-template #loadingStatus>
          <div class="status-loader">
            <div class="dot" *ngFor="let dot of dots" [@fadeInOut]></div>
          </div>
        </ng-template>
      </div>
    </div>

    <input
      *ngIf="!isModal"
      id="sample-id"
      type="text"
      placeholder="{{ 'sampleId.placeholder' | translate }}"
      class="form-input"
      [(ngModel)]="sampleId"
      (ngModelChange)="onSampleIdChange()"
    />
    <div *ngIf="isModal" class="static-field">
      {{ sampleId }}
    </div>
  </div>
</div>

<!-- Upload zones -->
<div class="form-grid">
  <!-- RNA-seq Upload -->
  <div
    class="upload-zone"
    [class.disabled]="!selectedBiobankId || isUploading || overviewData?.hasRnaSeq"
    role="button"
    tabindex="0"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDropRNA($event)"
  >
    <div class="form-label-row">
      <span class="form-label">{{ "uploadData.rnaMutation.rna.title" | translate }}</span>
      <a class="template-button" href="app/shared/assets/files/rnaseq_template.csv" download>
        {{ "uploadData.downloadTemplate" | translate }}
      </a>
    </div>
    <div class="drop-area">
      <lucide-angular name="upload" [size]="48" class="upload-icon"></lucide-angular>
      <div class="drop-text">{{ "uploadData.msg.drag" | translate }}</div>
      <button
        class="upload-button"
        type="button"
        (click)="triggerRNAFileInput()"
        (keydown.enter)="triggerRNAFileInput()"
        (keydown.space)="triggerRNAFileInput()"
      >
        {{ "button.chooseFile" | translate }}
      </button>
      <div class="form-hint">{{ "uploadData.rnaMutation.rna.upload" | translate }}</div>
    </div>
    <input type="file" #rnaInput accept=".csv,.tsv" hidden (change)="handleRNAFile($event)" />
  </div>

  <!-- Mutation Upload -->
  <div
    class="upload-zone"
    [class.disabled]="!selectedBiobankId || isUploading || overviewData?.hasMutation"
    role="button"
    tabindex="0"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDropMut($event)"
  >
    <div class="form-label-row">
      <span class="form-label">{{ "uploadData.rnaMutation.mutation.title" | translate }}</span>
      <a class="template-button" href="app/shared/assets/files/mutations_template.csv" download>
        {{ "uploadData.downloadTemplate" | translate }}
      </a>
    </div>
    <div class="drop-area">
      <lucide-angular name="upload" [size]="48" class="upload-icon"></lucide-angular>
      <div class="drop-text">{{ "uploadData.msg.drag" | translate }}</div>
      <button
        class="upload-button"
        type="button"
        (click)="triggerMutFileInput()"
        (keydown.enter)="triggerMutFileInput()"
        (keydown.space)="triggerMutFileInput()"
      >
        {{ "button.chooseFile" | translate }}
      </button>
      <div class="form-hint">{{ "uploadData.rnaMutation.mutation.upload" | translate }}</div>
    </div>
    <input type="file" #mutationInput accept=".csv,.tsv" hidden (change)="handleMutFile($event)" />
  </div>
</div>
